import { TranslationObject } from '../i18n/translation';

const namespace = 'psaStatuses';

const translations: TranslationObject = {
  kanBekreftes: {
    id: `${namespace}.requested`,
    nb: 'Bekreft ny bestilling',
    en: 'Verify incoming order',
  },
  manglerKapasitet: {
    id: `${namespace}.ingenKapasitet`,
    nb: 'Oppgi kapasiteten til praksisstedene',
    en: 'Enter capacities of work places',
  },
  overstyrtKapasitet: {
    id: `${namespace}.overstyrtKapasitet`,
    nb: 'Studiested har satt kapasitet',
    en: 'Capacity has been set by institution',
  },
  manglerFordeling: {
    id: `${namespace}.manglerFordeling`,
    nb: 'Fordel studenter til veiledere',
    en: 'Assign students to supervisors',
  },
  harKapasitet: {
    id: `${namespace}.harKapasitet`,
    nb: 'Bekreftet og sendt kapasitet',
    en: 'Confirmed and capacity sent',
  },
  klarForGjennomfoering: {
    id: `${namespace}.klarForGjennomfoering`,
    nb: 'Klar for praksis',
    en: 'Ready to start practice',
  },
  gjennomfoert: {
    id: `${namespace}.gjennomfoert`,
    nb: 'Denne aktiviteten er gjennomført',
    en: 'This activity has been completed',
  },
  avtalefeil: {
    id: `${namespace}.avtalefeil`,
    nb: 'Det finnes bestillinger/besvarelser som faller utenfor en avtale',
    en: 'There are orders/responses that are not connected to an agreement',
  },
};

export default translations;
